import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import MaintenancePage from '../components/MaintenancePage';

const checkMaintenance = WrappedComponent => {
  const CheckMaintenanceComponent = props => {
    if (!props.isInMaintenance) {
      return <WrappedComponent {...props} />;
    }

    return <MaintenancePage until={props.until} />;
  };

  CheckMaintenanceComponent.propTypes = {
    isInMaintenance: PropTypes.bool.isRequired,
    until: PropTypes.string,
  };

  CheckMaintenanceComponent.defaultProps = {
    until: '',
  };

  const mapStateToProps = state => {
    const {
      apiConnectivity: { maintenanceUntil },
    } = state;
    const now = moment();

    return {
      isInMaintenance: now.isBefore(maintenanceUntil),
      until: maintenanceUntil,
    };
  };

  return connect(mapStateToProps)(CheckMaintenanceComponent);
};

export default checkMaintenance;



// WEBPACK FOOTER //
// ../ui-components/auth/check-maintenance.jsx